interface PlatformIconProps {
  platform: string;
  enabled?: boolean;
  size?: "sm" | "md";
}

const platformConfig: Record<string, { icon: string; label: string; color: string }> = {
  windows: {
    icon: "window",
    label: "Windows",
    color: "bg-sky-500/15 text-sky-600 border-sky-500/30",
  },
  linux: {
    icon: "terminal",
    label: "Linux",
    color: "bg-amber-500/15 text-amber-600 border-amber-500/30",
  },
  macos: {
    icon: "desktop_mac",
    label: "macOS",
    color: "bg-violet-500/15 text-violet-600 border-violet-500/30",
  },
};

const disabledColor = "bg-muted text-muted-foreground/40 border-border";

export function PlatformIcon({ platform, enabled = true, size = "md" }: PlatformIconProps) {
  const config = platformConfig[platform] || {
    icon: "devices",
    label: platform,
    color: "bg-primary/10 text-primary border-primary/20",
  };

  const sizeClasses = size === "sm" ? "size-7 text-[16px]" : "size-8 text-[18px]";

  return (
    <div
      className={`inline-flex items-center justify-center rounded-lg border transition-all ${sizeClasses} ${
        enabled ? config.color : disabledColor
      } ${enabled ? "shadow-sm" : "opacity-60"}`}
      title={`${config.label}${enabled !== undefined ? (enabled ? " enabled" : " disabled") : ""}`}
    >
      <span className="material-symbols-outlined" style={{ fontSize: "inherit" }}>
        {config.icon}
      </span>
    </div>
  );
}
